import React, { memo } from 'react';
import {
  Box,
  TextField,
  IconButton,
} from '@mui/material';
import {
  Send as SendIcon,
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

interface ChatInputProps {
  inputMessage: string | undefined;
  setInputMessage: (message: string) => void;
  onSendMessage: () => void;
  onKeyPress: (event: React.KeyboardEvent) => void;
  isConnected: boolean;
  isLoading: boolean;
}

export const ChatInput = memo<ChatInputProps>(({
  inputMessage,
  setInputMessage,
  onSendMessage,
  onKeyPress,
  isConnected,
  isLoading,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'flex-end',
        gap: 1,
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <TextField
        fullWidth
        multiline
        maxRows={4}
        placeholder="Type your message here..."
        value={inputMessage || ''}
        onChange={(e) => setInputMessage(e.target.value)}
        onKeyPress={onKeyPress}
        disabled={!isConnected}
        variant="outlined"
        size="small"
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
          },
        }}
      />
      <IconButton
        onClick={onSendMessage}
        disabled={!inputMessage?.trim() || !isConnected || isLoading}
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: 'white',
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
          '&:disabled': {
            backgroundColor: theme.palette.action.disabled,
            color: theme.palette.action.disabled,
          },
        }}
      >
        <SendIcon />
      </IconButton>
    </Box>
  );
});

ChatInput.displayName = 'ChatInput';
